import {SDK_MODE} from '../embedded';

function getIsSDKLimitedMode() {
  return [
    SDK_MODE.onlyGuestForm,
    SDK_MODE.onlyIV,
    SDK_MODE.guestRegistrationOnly,
    SDK_MODE.propertyLink,
  ].includes(window.ChekinProSettings?.mode as SDK_MODE);
}

export {getIsSDKLimitedMode};
